module.exports = __webpack_public_path__ + "media/images/pic/brodno/offer/trainers-e53c2e36ac0dbdc0a7fe4d45c69af310.jpg";